AgrimarketDirectives.directive('agrimarketEditableTable', function ($compile) {
	return {
		transclude: false,
		replace: false,
		restrict: 'EA',
		compile: function (elm, attrs) {
			var key = attrs.agrimarketEditableTableIddefaulttable;
			elm.removeAttr('agrimarket-editable-table'); 
			elm.removeAttr('agrimarket-editable-table-iddefaulttable');
			elm.attr('editable-content-visible', 'false');
			elm.attr('editable-content-body', 'globalLabels.Edit_Table');
			elm.attr('editable-ico-visible', 'modeEdition');
			elm.attr('editable-ico-action', 'openPopEditableTable('+ key + ')');
			elm.attr('editable','');
			var fn = $compile(elm);
			return function (scope) {
				fn(scope);
			};
		}
	};
});
